import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledVideo = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
`;

const Video = (props) => {
    const ref = useRef();

    useEffect(() => {
        props.peer.on('stream', stream => {
            ref.current.srcObject = stream;
        })
    }, [props.peer]);

    return (
        <StyledVideo playsInline autoPlay ref={ref} />
    );
}

export default Video;
